<template>
  <div>
    <vx-card title="Users Role Management" class="mb-4">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-input
            v-model="searchQuery"
            class="w-full md:w-1/3"
            placeholder="Search users by name or email..."
          />
        </div>
      </div>

      <!-- Roles Table -->
      <vs-table
        stripe
        ref="table"
        :data="filteredUsers"
        :loading="isLoading"
        class="mt-4"
        pagination
        max-items="10"
      >
        <template slot="thead">
          <vs-th>User Name</vs-th>
          <vs-th>Description</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Role</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" :data="user" v-for="(user, indextr) in data">
            <vs-td>{{ user.name }}</vs-td>
            <vs-td>{{ user.emailAddress }}</vs-td>
            <vs-td>{{ user.generalStatus }} </vs-td>
            <vs-td
              ><div class="flex flex-wrap gap-2">
                <vs-chip
                  v-for="role in getUserRoles(user)"
                  :key="role.id"
                  class="mr-2"
                >
                  {{ role.name }}
                </vs-chip>
              </div>
            </vs-td>
            <vs-td>
              <div class="flex items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                  @click="openEditForm(user)"
                />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- Form Dialog -->

    <user-role-setting
      :visible="isFormVisible"
      :user-data="selectedUser"
      :is-editing="isEditing"
      @submit="handleFormSubmit"
      @cancel="closeForm"
      v-if="isFormVisible"
    />
  </div>
</template>

<script>
import UserRoleSetting from './UserRoleSetting.vue'

export default {
  components: {
    UserRoleSetting,
  },

  data() {
    return {
      users: [],
      searchQuery: '',
      isLoading: false,
      isFormVisible: false,
      isEditing: false,
      selectedRole: null,
    }
  },

  computed: {
    formTitle() {
      return 'Edit User Role'
    },
    filteredUsers() {
      if (!this.searchQuery) return this.users

      const query = this.searchQuery.toLowerCase()
      return this.users.filter(
        (user) =>
          user.name.toLowerCase().includes(query) ||
          user.emailAddress.toLowerCase().includes(query)
      )
    },
  },

  created() {
    this.fetchUsers()
  },

  methods: {
    async fetchUsers() {
      try {
        this.isLoading = true
        await this.$store
          .dispatch('users/fetchUsers')
          .then((resp) => {
            this.users = resp.data
          })
          .catch(() => {})
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to fetch users',
          color: 'danger',
        })
      } finally {
        this.isLoading = false
      }
    },
    getUserRoles(user) {
      //roles are nested in userRole.role
      if (user.userRole?.role) {
        return [user.userRole.role]
      }
      // If user has multiple roles
      if (user.userRoles) {
        return user.userRoles.map((ur) => ur.role)
      }
      // Fallback if no roles
      return []
    },
    async openEditForm(user) {
      this.isEditing = true
      await this.fetchRoles()
      this.selectedUser = { ...user }
      this.isFormVisible = true
    },
    closeForm() {
      this.isFormVisible = false
      this.selectedUser = null
    },
    handleDialogOpen() {
      this.fetchRoles()
    },
    async fetchRoles() {
      try {
        this.isLoading = true
        await this.$store
          .dispatch('role/fetchRoles')
          .then((resp) => {
            this.roles = resp.data
          })
          .catch(() => {})
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to fetch roles',
          color: 'danger',
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleFormSubmit(formData) {
      try {
        let successMessage = 'Updated Successful'
        let successText = 'Information has successfully updated'
        let failMessage = 'Updated Failed'
        let failText = 'Fail to update account information'

        this.$store
          .dispatch('users/updateUser', formData)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: successMessage,
              text: successText,
            })
          })
          .catch((err) => {
            let message = failText
            if (err.response.errors && err.response.errors.length > 0) {
              message = err.response.errors[0]
            } else {
              message = err.response.message
            }
            this.$vs.notify({
              color: 'danger',
              title: failMessage,
              text: message,
            })
          })
          .finally(() => {
            this.fetchUsers()
            this.closeForm()
          })
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to update role',
          color: 'danger',
        })
      }
    },
  },
}
</script>
